// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_string from "../../../../../../node_modules/rescript/lib/es6/js_string.js";
import * as Belt_Float from "../../../../../../node_modules/rescript/lib/es6/belt_Float.js";
import * as Caml_array from "../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Pervasives from "../../../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Belt_Result from "../../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as UrlUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.mjs";
import * as City$PorterinFeature from "./City.mjs";
import * as UtmHelper$PorterinFeature from "./UtmHelper.mjs";
import * as CookieHelpers$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/helpers/CookieHelpers.mjs";
import * as CommonHelper$PorterinFeature from "./CommonHelper.mjs";
import * as CookieConstants$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/constants/CookieConstants.mjs";
import * as RoutingHelper$PorterinFeature from "./RoutingHelper.mjs";
import * as CountryConstants$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/constants/CountryConstants.mjs";
import * as QueryParamsConstructor$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/query-params/QueryParamsConstructor.mjs";
import * as FareEstimateRepoHelper$PorterinFeature from "./FareEstimateRepoHelper.mjs";
import * as FareEstimateResultFormHelper$PorterinFeature from "./FareEstimateResultFormHelper.mjs";
import * as FareEstimateResultQueryParams$PorterinFeature from "../../../containers/fare-estimate/domain/entities/FareEstimateResultQueryParams.mjs";

function getUtmParams(param_value) {
  var utm_obj = UrlUtils$Catalyst.getURLParams(UrlUtils$Catalyst.getSearchParams(window.location.href));
  $$Array.iteri((function (index, param) {
          var param_value_status = Belt_Option.getWithDefault(Js_dict.get(utm_obj, param), "");
          if (param_value_status.length === 0 && index < param_value.length) {
            utm_obj[param] = Caml_array.get(param_value, index);
            return ;
          }
          
        }), UtmHelper$PorterinFeature.utm_params_keys);
  return Belt_Option.getWithDefault(QueryParamsConstructor$Catalyst.create(utm_obj), "");
}

function getUtmParamsEstimateFormEdit(param_value) {
  var utm_obj = UrlUtils$Catalyst.getURLParams(UrlUtils$Catalyst.getSearchParams(window.location.href));
  var new_dict = {};
  $$Array.iteri((function (index, param) {
          var param_value_status = Belt_Option.getWithDefault(Js_dict.get(utm_obj, param), "");
          if (param_value_status.length === 0 && index < param_value.length) {
            new_dict[param] = Caml_array.get(param_value, index);
          } else {
            new_dict[param] = param_value_status;
          }
        }), UtmHelper$PorterinFeature.utm_params_keys);
  return Belt_Option.getWithDefault(QueryParamsConstructor$Catalyst.create(new_dict), "");
}

function getDefaultParamsValues(source) {
  return [
          "website_fare_estimate_ssr",
          "default_" + source,
          "default_" + source,
          "default_" + source,
          ""
        ];
}

function fareEstimateResultRedirectUrlOms(redirect_url, service_category, source, is_desktop, consent_for_callback) {
  var redirectUrl = redirect_url + "&service_category=" + service_category + "&is_device_mobile=" + (
    is_desktop ? "false" : "true"
  ) + "&landing_page=nw&" + getUtmParamsEstimateFormEdit(getDefaultParamsValues(source)) + "&consent_for_callback=" + (
    consent_for_callback ? "false" : "true"
  );
  var localeCookie = CookieHelpers$PorterinUtils.getCookie(CookieConstants$PorterinUtils.next_locale);
  var urlSplit = redirectUrl.split("/");
  return RoutingHelper$PorterinFeature.getUrlWithLocale(localeCookie, "/" + Caml_array.get(urlSplit, urlSplit.length - 1 | 0) + "", "");
}

function requirementToLabel(requirement, content) {
  switch (requirement) {
    case /* Personal */0 :
        return content.personal.title;
    case /* Business */1 :
        return content.business.title;
    case /* HouseShift */2 :
        return "";
    
  }
}

function requirementToString(requirement) {
  switch (requirement) {
    case /* Personal */0 :
        return "personal";
    case /* Business */1 :
        return "business";
    case /* HouseShift */2 :
        return "house_shift";
    
  }
}

function requirementfromString(requirement) {
  switch (requirement) {
    case "business" :
        return /* Business */1;
    case "personal" :
        return /* Personal */0;
    default:
      return /* Personal */0;
  }
}

function toApiInput(fare_estimate_form, cityOpt, param) {
  var city = cityOpt !== undefined ? cityOpt : "";
  var form_data = fare_estimate_form._0;
  return {
          geo_region: City$PorterinFeature.cityToGeoRegionId(city).toString(),
          pickup_address: form_data.pickup_address,
          drop_address: form_data.drop_address,
          name: form_data.name,
          mobile: form_data.mobile,
          requirement: requirementToString(form_data.requirement),
          service_category: form_data.service_category,
          consent_for_callback: form_data.consent_for_callback
        };
}

function getUtmKeyValues(source) {
  var url_params = UrlUtils$Catalyst.getURLParams(UrlUtils$Catalyst.getSearchParams(window.location.href));
  var default_param_values = getDefaultParamsValues(source);
  return $$Array.mapi((function (index, param) {
                var param_value = Belt_Option.getWithDefault(Js_dict.get(url_params, param), "");
                if (param_value.length === 0) {
                  return [
                          param,
                          Caml_array.get(default_param_values, index)
                        ];
                } else {
                  return [
                          param,
                          param_value
                        ];
                }
              }), UtmHelper$PorterinFeature.utm_params_keys);
}

function getParamValue(params, key, $$default) {
  return Belt_Option.getWithDefault(Js_dict.get(UrlUtils$Catalyst.getURLParams(UrlUtils$Catalyst.getSearchParams(params)), key), $$default);
}

function fireGTEEventsOnLeadCreated(redirect_url, service_category, category, source, send_unregistered_event_flag) {
  var params = getUtmKeyValues(source);
  params.push([
        "service_category",
        "service_category"
      ]);
  var fare_estimate_parameters = FareEstimateResultFormHelper$PorterinFeature.getFareEstimateFormParameter(FareEstimateResultQueryParams$PorterinFeature.queryMapper(UrlUtils$Catalyst.getURLParams(CommonHelper$PorterinFeature.addParamsToUrl(redirect_url, params))));
  FareEstimateRepoHelper$PorterinFeature.fireUnregEventIfCustNotExist(fare_estimate_parameters, send_unregistered_event_flag);
}

function getCallbackReqKeyValuePairs(data) {
  return [
          [
            "result",
            Pervasives.string_of_bool(data.result)
          ],
          [
            "prev_callback_req_id_present",
            Pervasives.string_of_bool(data.prev_callback_req_id_present)
          ],
          [
            "callback_request_id",
            data.callback_request_id
          ],
          [
            "is_existing_cust",
            Pervasives.string_of_bool(data.is_existing_cust)
          ],
          [
            "lead_entry_created",
            Pervasives.string_of_bool(data.lead_entry_created)
          ]
        ];
}

function getCallbackReqKeyValuePairsV1(data) {
  return [
          [
            "result",
            Pervasives.string_of_bool(data.result)
          ],
          [
            "prev_callback_req_id_present",
            Pervasives.string_of_bool(data.prev_callback_req_id_present)
          ],
          [
            "callback_request_id",
            data.callback_request_id
          ],
          [
            "is_existing_cust",
            Pervasives.string_of_bool(data.is_existing_cust)
          ],
          [
            "lead_entry_created",
            Pervasives.string_of_bool(data.lead_entry_created)
          ]
        ];
}

function makeCallbackDataQueryParams(callback_request_data) {
  return getCallbackReqKeyValuePairs(callback_request_data).reduce((function (param_url, param) {
                return param_url + ("&" + param[0] + "=" + window.encodeURIComponent(param[1]) + "");
              }), "");
}

function makeCallbackDataQueryParamsV1(callback_request_data) {
  return getCallbackReqKeyValuePairsV1(callback_request_data).reduce((function (param_url, param) {
                return param_url + ("&" + param[0] + "=" + window.encodeURIComponent(param[1]) + "");
              }), "");
}

function updateRedirectUrl(data, updated_url) {
  return Belt_Result.map(data, (function (success_data) {
                return {
                        redirect_url: updated_url,
                        callback_request_data: success_data.callback_request_data
                      };
              }));
}

function updateRedirectUrlV1(data, updated_url) {
  return Belt_Result.map(data, (function (success_data) {
                return {
                        redirect_url: updated_url,
                        callback_request_data: success_data.callback_request_data
                      };
              }));
}

function getLandmarkLocation(landmark_location) {
  return Js_string.replaceByRe(/[+]/g, " ", Belt_Option.getWithDefault(landmark_location, ""));
}

function getLocationCoordinates(location_coordinates) {
  return Belt_Option.getWithDefault(Belt_Float.fromString(Belt_Option.getWithDefault(location_coordinates, "0.0")), 0.0);
}

function isCallbackConsentMandatory(consent_for_callback, country) {
  if (country === CountryConstants$PorterinUtils.tr && !consent_for_callback) {
    return {
            TAG: /* Error */1,
            _0: ""
          };
  } else {
    return {
            TAG: /* Ok */0,
            _0: true
          };
  }
}

function replaceFareEstimate(input) {
  return Js_string.replace("fare_estimate_mob", "fare-estimate", input);
}

function fareEstimateV2RedirectUrl(redirect_url, service_category, source, is_desktop) {
  var fare_estimate_url = Js_string.replace("fare_estimate_mob", "fare-estimate", redirect_url);
  return fare_estimate_url + "&service_category=" + service_category + "&is_device_mobile=" + (
          is_desktop ? "false" : "true"
        ) + "&landing_page=nw&" + getUtmParamsEstimateFormEdit(getDefaultParamsValues(source));
}

function fareEstimateResultRedirectUrlEdit(redirect_url, service_category, source, is_desktop) {
  return redirect_url + "&service_category=" + service_category + "&is_device_mobile=" + (
          is_desktop ? "false" : "true"
        ) + "&landing_page=nw&" + getUtmParamsEstimateFormEdit(getDefaultParamsValues(source));
}

function enableBookingFlow(mobile, is_desktop) {
  return !is_desktop;
}

export {
  getUtmParams ,
  getUtmParamsEstimateFormEdit ,
  getDefaultParamsValues ,
  fareEstimateResultRedirectUrlOms ,
  requirementToLabel ,
  requirementToString ,
  requirementfromString ,
  toApiInput ,
  getUtmKeyValues ,
  getParamValue ,
  fireGTEEventsOnLeadCreated ,
  getCallbackReqKeyValuePairs ,
  getCallbackReqKeyValuePairsV1 ,
  makeCallbackDataQueryParams ,
  makeCallbackDataQueryParamsV1 ,
  updateRedirectUrl ,
  updateRedirectUrlV1 ,
  getLandmarkLocation ,
  getLocationCoordinates ,
  isCallbackConsentMandatory ,
  replaceFareEstimate ,
  fareEstimateV2RedirectUrl ,
  fareEstimateResultRedirectUrlEdit ,
  enableBookingFlow ,
}
/* City-PorterinFeature Not a pure module */
